module.exports = ".toggle-map-satellite {\n  position: fixed !important;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./node_modules/postcss-loader/lib??embedded!./node_modules/less-loader/dist/cjs.js??ref--9-3!./src/app/styles/map.less
// module id = ./node_modules/raw-loader/index.js!./node_modules/postcss-loader/lib/index.js??embedded!./node_modules/less-loader/dist/cjs.js??ref--9-3!./src/app/styles/map.less
// module chunks = styles